import * as React from 'react'
import styled from 'styled-components'
import theme from 'theme'
import useOutsideClick from 'hooks/useOutsideClick'
import Modal from './Modal/ErrorModal'

type Props = {
  error: boolean
}

export default function ErrorModalWrapper(props: Props) {
  const [showModal, setShowModal] = React.useState(false)

  const outsideClickRef = useOutsideClick(() => {
    setShowModal(false)
  })

  React.useEffect(() => {
    setShowModal(props.error)
  }, [props.error])

  return (
    <Wrapper ref={outsideClickRef}>
      {showModal && (
        <div
          className="modal"
          data-cy-state="show-modal"
          data-cy-handle="open-modal-btn"
          onClick={() => setShowModal(!showModal)}
        />
      )}
      {showModal && (
        <Modal data-cy-state="show-modal" setShowModal={setShowModal} />
      )}
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  gap: ${theme.spacing('xxs')};
  text-decoration: underline;

  > .modal {
    position: fixed;
    top: 0;
    left: 0;
    z-index: ${theme.zIndex
      .theme_molecules_account_cartsummary_sharecart_errormodal_wrapper};
    width: 100vw;
    height: 100vh;
    background-color: rgba(30, 30, 30, 0.9);
  }
`
